module.exports = __webpack_public_path__ + "static/media/24.2d0ef8b7.mp3";